import storage from "@/utils/storage";

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    error: null,
  },

  getters: {
    cartItems: (state) => state.items,
    cartTotal: (state) => {
      return state.items.reduce(
        (total, item) => total + item.price * item.quantity,
        0,
      );
    },
    cartItemCount: (state) => {
      return state.items.reduce((count, item) => count + item.quantity, 0);
    },
    isLoading: (state) => state.loading,
    error: (state) => state.error,
  },

  mutations: {
    SET_CART(state, items) {
      state.items = items || [];
      storage.set("cart", state.items);
    },

    ADD_TO_CART(state, item) {
      const existingItem = state.items.find(
        (i) => i.productId === item.productId,
      );
      if (existingItem) {
        existingItem.quantity += item.quantity;
      } else {
        state.items.push(item);
      }
      storage.set("cart", state.items);

      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("cart-updated", {
            detail: { count: state.items.reduce((c, i) => c + i.quantity, 0) },
          }),
        );
      }
    },

    UPDATE_QUANTITY(state, { productId, quantity }) {
      const item = state.items.find((i) => i.productId === productId);
      if (item) {
        if (quantity <= 0) {
          state.items = state.items.filter((i) => i.productId !== productId);
        } else {
          item.quantity = quantity;
        }
        storage.set("cart", state.items);

        if (typeof window !== "undefined") {
          window.dispatchEvent(
            new CustomEvent("cart-updated", {
              detail: {
                count: state.items.reduce((c, i) => c + i.quantity, 0),
              },
            }),
          );
        }
      }
    },

    REMOVE_FROM_CART(state, productId) {
      state.items = state.items.filter((i) => i.productId !== productId);
      storage.set("cart", state.items);

      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("cart-updated", {
            detail: { count: state.items.reduce((c, i) => c + i.quantity, 0) },
          }),
        );
      }
    },

    CLEAR_CART(state) {
      state.items = [];
      storage.set("cart", []);

      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("cart-updated", { detail: { count: 0 } }),
        );
      }
    },

    SET_LOADING(state, loading) {
      state.loading = loading;
    },

    SET_ERROR(state, error) {
      state.error = error;
    },
  },

  actions: {
    initializeCart({ commit }) {
      const savedCart = storage.get("cart");
      if (savedCart && Array.isArray(savedCart)) {
        commit("SET_CART", savedCart);
      } else {
        commit("SET_CART", []);
      }
    },

    addToCart({ commit, dispatch }, { product, quantity = 1, event }) {
      // Create flying animation with image clone only
      if (event && event.target) {
        dispatch("animateToCart", { product, event });
      }

      const cartItem = {
        productId: product.id,
        name: product.name,
        price: product.price,
        quantity: quantity,
        image: product.image,
        stock: product.stock,
        unit: product.unit,
        slug: product.slug,
      };

      commit("ADD_TO_CART", cartItem);
    },

    updateQuantity({ commit }, { productId, quantity }) {
      commit("UPDATE_QUANTITY", { productId, quantity });
    },

    removeFromCart({ commit }, productId) {
      commit("REMOVE_FROM_CART", productId);
    },

    clearCart({ commit }) {
      commit("CLEAR_CART");
    },

    animateToCart({ getters }, { product, event }) {
      const button = event.target.closest(".add-button");
      if (!button) return;

      const productCard = button.closest(".product-card");
      if (!productCard) return;

      const cartBtn = document.querySelector(".cart-btn");
      if (!cartBtn) return;

      const imageElement = productCard.querySelector(
        ".product-image img, .placeholder-image",
      );
      if (!imageElement) return;

      const buttonRect = button.getBoundingClientRect();
      const cartRect = cartBtn.getBoundingClientRect();
      const imageRect = imageElement.getBoundingClientRect();

      const clone = imageElement.cloneNode(true);

      // Style the clone
      clone.style.position = "fixed";
      clone.style.left = imageRect.left + "px";
      clone.style.top = imageRect.top + "px";
      clone.style.width = imageRect.width + "px";
      clone.style.height = imageRect.height + "px";
      clone.style.borderRadius = "12px";
      clone.style.objectFit = "cover";
      clone.style.zIndex = "9999";
      clone.style.transition = "all 2s cubic-bezier(0.2, 0.9, 0.4, 1.1)"; // 0.8s sekinroq
      clone.style.opacity = "1";
      clone.style.pointerEvents = "none";
      clone.style.boxShadow = "0 4px 15px rgba(0,0,0,0.2)";

      document.body.appendChild(clone);
      clone.offsetHeight;

      // Animate to cart - 0.8s
      clone.style.left =
        cartRect.left + cartRect.width / 2 - imageRect.width / 2 + "px";
      clone.style.top =
        cartRect.top + cartRect.height / 2 - imageRect.height / 2 + "px";
      clone.style.width = "0px";
      clone.style.height = "0px";
      clone.style.opacity = "0";
      clone.style.transform = "scale(0)";

      setTimeout(() => {
        clone.remove();
        cartBtn.classList.add("cart-bounce");
        setTimeout(() => cartBtn.classList.remove("cart-bounce"), 300);

        const badge = cartBtn.querySelector(".cart-badge");
        if (badge) {
          badge.classList.add("cart-badge-pulse");
          setTimeout(() => badge.classList.remove("cart-badge-pulse"), 400);
        }
      }, 800); // 800ms ga mos
    },
  },
};
